// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import ReactDOM from 'react-dom'
import LanguageProvider from '../src/providers/LanguageProvider'
import WindowDimensionsProvider from '../src/providers/WindowDimensionsProvider'
import ScreensRouting from '../src/screens/Routing'

const App = () => {
  return (
    <WindowDimensionsProvider>
      <LanguageProvider>
        {({ site, scope }) => (
          <ScreensRouting site={site} scope={scope} />)}
      </LanguageProvider>
    </WindowDimensionsProvider>

  )
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<App />, document.body.appendChild(document.createElement('div')))
})
